import React from "react";
import { Link } from "react-router-dom";
import ExternalLink from "./common/externalLink";

import { renderReviewAvgsSimple } from "../services/reviewService";

const InstituteCard = ({ institute }) => {
  const { phoneNumbers, emails, website } = institute;
  const { town } = institute;
  const { province } = institute;
  const { country } = institute;

  const title = !institute.abbrev
    ? institute.name
    : `${institute.name} (${institute.abbrev})`;

  let reviewAvgs = null;
  if (institute.reviewAvgs) {
    reviewAvgs = institute.reviewAvgs;
  }
  return (
    // <div className="card" style={{ width: "46rem", margin: "1rem" }}>
    <div className="card shadow mt-4" style={{ margin: "1rem" }}>
      {/* <img className="card-img-top" src="..." alt="Card image cap" /> */}
      <div className="card-body">
        <p className="float-right">{institute.type}</p>
        {/* <i className="fa fa-heart float-right" aria-hidden="true"></i> */}
        <h5 className="card-title">
          <Link to={`/institutes/details/${institute.id}`}>{title}</Link>
        </h5>
        {/* <i className="fa fa-map-marker" aria-hidden="true"></i> */}
        <p className="card-text">{`${country} . ${province} . ${town}`}</p>

        {renderReviewAvgsSimple(reviewAvgs)}

        <p className="card-text mt-3">
          {phoneNumbers[0] ? (
            <>
              <i className="fa fa-phone" aria-hidden="true"></i>
              {phoneNumbers[0]}
            </>
          ) : null}

          {emails[0] ? (
            <>
              <i className="fa fa-envelope ml-3" aria-hidden="true"></i>
              {emails[0]}
            </>
          ) : null}

          {website ? (
            <>
              <i className="fa fa-globe ml-3" aria-hidden="true"></i>
              <ExternalLink url={`https://${website}`} label={website} />
            </>
          ) : null}
        </p>
      </div>
    </div>
  );
};

export default InstituteCard;
